// ============================================================================
//  Tipos del padrón (/personal) — compartidos entre servidor y cliente.
//  Puerto de las filas que devolvía controlador/app/db.py::list_trabajadores/
//  list_vehiculos/list_fotochecks, con nombres en inglés (ver glosario de
//  CLAUDE.md: trabajador→worker, vehículo→vehicle, fotocheck→badge).
// ============================================================================

export type BadgeType = 'worker' | 'vehicle';
export type BadgeStatus = 'stock' | 'assigned' | 'lost' | 'retired';
export type AssignmentEndReason = 'reassigned' | 'return' | 'lost' | 'retired';
export type UnassignReason = 'return' | 'lost' | 'retired';
export type WorkerSource = 'manual' | 'csv' | 'api';

export interface Worker {
  id: number;
  dni: string; // documento (DNI/CE) — columna document_id, clave única
  name: string;
  lastName: string;
  role: string;
  companyName: string; // columna company
  privilege: boolean;
  area: string;
  bloodType: string;
  medicalExam: string;
  trainings: string[];
  source: WorkerSource;
  isActive: boolean;
  // asignación vigente, si tiene ('' si no)
  badgeMac: string;
  badgeCode: string;
  // users.id de quien lo creó / editó por última vez; null = sin sesión o
  // anterior a 2026-10-09.
  createdBy: number | null;
  updatedBy: number | null;
}

/** Nombre para mostrar donde sólo cabe uno (tablero, /pruebas, buscador de
 *  asignación). Una fila anterior al split de apellido tiene el nombre
 *  completo en `name` y `lastName` vacío: se ve exactamente igual. */
export function workerDisplayName(w: Pick<Worker, 'name' | 'lastName'>): string {
  return `${w.name} ${w.lastName}`.trim();
}

export interface Vehicle {
  id: number;
  plate: string;
  type: string;
  company: string;
  driver: string;
  isActive: boolean;
  badgeMac: string;
  badgeCode: string;
}

/** Vista enriquecida de `badges` + su asignación vigente (si tiene). */
export interface BadgeRow {
  mac: string;
  type: BadgeType;
  code: string;
  status: BadgeStatus;
  notes: string;
  createdAt: number;
  assignedSubjectType: BadgeType | null;
  assignedSubjectId: number | null;
  assignedName: string; // nombre del trabajador o placa del vehículo; '' si no asignado
  assignedSince: number | null;
}

export interface AssignmentHistoryRow {
  id: number;
  badgeMac: string;
  subjectType: BadgeType;
  subjectId: number;
  subjectName: string;
  startedAt: number;
  endedAt: number | null;
  endReason: AssignmentEndReason | null;
}

export interface WorkerInput {
  dni: string;
  name: string;
  lastName: string;
  role: string;
  companyName: string;
  privilege: boolean;
  area?: string;
  bloodType?: string;
  medicalExam?: string;
  trainings?: string[];
}

export interface VehicleInput {
  plate: string;
  type?: string;
  company?: string;
  driver?: string;
}
